// extracted by mini-css-extract-plugin
module.exports = {"container":"Train_container__1nITz","train":"Train_train__5GfvA","line":"Train_line__34Db_","green":"Train_green__1-8AY","red":"Train_red__20_2P"};